export enum ONLINE_COURSE_PAYMENT {
    PENDING = 'PENDING', //รอยืนยันการชำระเงิน
    CONFIRMED = 'CONFIRMED', //ยืนยันการชำระเงินแล้ว
    REJECT = 'REJECT'
}

export const renderStatus = (status: string): string => {
    if (status === ONLINE_COURSE_PAYMENT.CONFIRMED) {
        return "ยืนยันการชำระเงินแล้ว" // i18n-ignore: status key for StatusCustom (used as color id; StatusCustom translates the text)
    }
    else if (status === ONLINE_COURSE_PAYMENT.PENDING) {
        return "รอยืนยันการชำระเงิน" // i18n-ignore: status key for StatusCustom (used as color id; StatusCustom translates the text)
    }
    else if (status === ONLINE_COURSE_PAYMENT.REJECT) {
        return "ไม่อนุมัติ" // i18n-ignore: status key for StatusCustom (used as color id; StatusCustom translates the text)
    }
    return ""
}